import { useEffect } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import "@/index.css";
import axios from "axios";

import { AuthProvider } from "@/context/AuthContext";
import { CartProvider } from "@/context/CartContext";
import { Toaster } from "sonner";

import Nav from "@/components/layout/Nav";
import Footer from "@/components/layout/Footer";
import WhatsAppButton from "@/components/layout/WhatsAppButton";
import LeadPopup from "@/components/LeadPopup";
import ScrollToTop from "@/components/ScrollToTop";

import Home from "@/pages/Home";
import Category from "@/pages/Category";
import ProductDetail from "@/pages/ProductDetail";
import Cart from "@/pages/Cart";
import Checkout from "@/pages/Checkout";
import OrderSuccess from "@/pages/OrderSuccess";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import CustomDesign from "@/pages/CustomDesign";
import About from "@/pages/About";

import AdminLogin from "@/pages/admin/AdminLogin";
import AdminLayout from "@/pages/admin/AdminLayout";
import AdminAnalytics from "@/pages/admin/AdminAnalytics";
import AdminProducts from "@/pages/admin/AdminProducts";
import AdminOrders from "@/pages/admin/AdminOrders";
import AdminLeads from "@/pages/admin/AdminLeads";
import AdminDesignEnquiries from "@/pages/admin/AdminDesignEnquiries";
import AdminShopTheLook from "@/pages/admin/AdminShopTheLook";
import AdminInstagramSync from "@/pages/admin/AdminInstagramSync";

axios.defaults.withCredentials = true;
const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

function TrackVisit() {
  useEffect(() => {
    let sid = localStorage.getItem("teak_sid");
    if (!sid) {
      sid = crypto.randomUUID();
      localStorage.setItem("teak_sid", sid);
    }
    axios.post(`${API}/events`, { event_type: "visit", session_id: sid }).catch(() => {});
  }, []);
  return null;
}

function StorefrontShell({ children }) {
  return (
    <div className="min-h-screen flex flex-col">
      <Nav />
      <main className="flex-1">{children}</main>
      <Footer />
      <WhatsAppButton />
      <LeadPopup />
    </div>
  );
}

function App() {
  return (
    <AuthProvider>
      <CartProvider>
        <BrowserRouter>
          <ScrollToTop />
          <TrackVisit />
          <Toaster theme="dark" position="top-right" />
          <Routes>
            <Route path="/" element={<StorefrontShell><Home /></StorefrontShell>} />
            <Route path="/category/:slug" element={<StorefrontShell><Category /></StorefrontShell>} />
            <Route path="/product/:slug" element={<StorefrontShell><ProductDetail /></StorefrontShell>} />
            <Route path="/cart" element={<StorefrontShell><Cart /></StorefrontShell>} />
            <Route path="/checkout" element={<StorefrontShell><Checkout /></StorefrontShell>} />
            <Route path="/order/:id" element={<StorefrontShell><OrderSuccess /></StorefrontShell>} />
            <Route path="/login" element={<StorefrontShell><Login /></StorefrontShell>} />
            <Route path="/register" element={<StorefrontShell><Register /></StorefrontShell>} />
            <Route path="/custom-design" element={<StorefrontShell><CustomDesign /></StorefrontShell>} />
            <Route path="/about" element={<StorefrontShell><About /></StorefrontShell>} />

            <Route path="/admin/login" element={<AdminLogin />} />
            <Route path="/admin" element={<AdminLayout />}>
              <Route index element={<AdminAnalytics />} />
              <Route path="analytics" element={<AdminAnalytics />} />
              <Route path="products" element={<AdminProducts />} />
              <Route path="shop-the-look" element={<AdminShopTheLook />} />
              <Route path="instagram" element={<AdminInstagramSync />} />
              <Route path="orders" element={<AdminOrders />} />
              <Route path="leads" element={<AdminLeads />} />
              <Route path="design-enquiries" element={<AdminDesignEnquiries />} />
            </Route>
          </Routes>
        </BrowserRouter>
      </CartProvider>
    </AuthProvider>
  );
}

export default App;
